import { useState } from 'react';
import styles from './TooltipGoftino.module.scss';
import Box from '@/components/UI/box/Box';
interface TooltipProps {
  text: string;
}
const TooltipGoftino: React.FC<TooltipProps> = ({
  text
}) => {
  return <Box className={styles['tooltip-container']} data-sentry-element="Box" data-sentry-component="TooltipGoftino" data-sentry-source-file="TooltipGoftino.tsx">
      <Box className={styles['tooltip']} data-sentry-element="Box" data-sentry-source-file="TooltipGoftino.tsx">{text}</Box>
    </Box>;
};
export default TooltipGoftino;